import type { RouteRecordRaw } from 'vue-router'
import BbsList from '@/views/frontDesk/bbs/list.vue'
import BbsDetail from '@/views/frontDesk/bbs/detail.vue'
import BbsTabel from '@/views/frontDesk/bbs/tabel.vue'
import MemberBbsTabel from '@/views/frontDesk/bbs/memberTabel.vue'

// 招商活动
export const BbsRoute: Array<RouteRecordRaw> = [
  {
    path: 'bbsList',
    name: 'BbsList',
    meta: {
      title: '社区营销' 
    },
    component: BbsList
  },
  {
    path: 'bbsList/bbsDetail/:id',
    name: 'BbsDetail',
    meta: {
      title: '活动详情' 
    },
    component: BbsDetail
  },
  {
    path: 'bbsList/memberBbsTabel/:id',
    name: 'MemberBbsTabel',
    meta: {
      title: '会员报名表' 
    },
    component: MemberBbsTabel
  },
  {
    path: 'bbsList/bbsTabel/:id',
    name: 'BbsTabel',
    meta: {
      title: '非会员报名表' 
    },
    component: BbsTabel
  },
]

export default BbsRoute